import * as yup from 'yup';

export const FeatureSchema = yup.object({
  id: yup.number().defined(),
  name: yup.string().defined(),
  description: yup.string().nullable().defined(),
  internal_keycode: yup.string().nullable().defined(),
});

export type Feature = yup.InferType<typeof FeatureSchema>;

export const CreatedFeaturesResponseSchema = yup.object({
  features: yup.array(FeatureSchema.defined()).defined(),
});

export type CreatedFeaturesResponse = yup.InferType<
  typeof CreatedFeaturesResponseSchema
>;

export const OrgFeatureSchema = yup.object({
  feature_id: yup.number().defined(),
});

export type OrgFeature = yup.InferType<typeof OrgFeatureSchema>;

export const OrgFeaturesResponseSchema = yup.object({
  org_features: yup.array(OrgFeatureSchema.defined()).defined(),
});

export type OrgFeaturesResponse = yup.InferType<
  typeof OrgFeaturesResponseSchema
>;
